/** @jsx jsx */
import { useState } from 'react'
import { jsx } from '@emotion/core'
import uniqid from 'uniqid'

import { VIEWS } from '../constants'
import { Context } from '../context'

const StoreProvider = ({ children }) => {
  // access
  const [hasAccess, setHasAccess] = useState(undefined)
  const [surveyToken, setSurveyToken] = useState()

  // surveys
  const [surveys, setSurveys] = useState([])
  const [surveysLoading, setSurveysLoading] = useState(true)
  const [surveyFeedback, setSurveyFeedback] = useState(null)
  const [surveyResponse, setSurveyResponse] = useState([])
  const [feedbackType, setFeedbackType] = useState(null)
  const [settings, setSettings] = useState()

  const removeSurvey = (id) => {
    const newSurveys = [...surveys].filter((el) => el.id !== id)
    setSurveys(newSurveys)
  }

  const switchSurveyStatus = (id, value) => {
    const newSurveys = [...surveys]
    newSurveys.forEach((el) => {
      if (el.id === id) {
        el.active = value
      }
    })
    setSurveys(newSurveys)
  }

  const switchSavingAttributes = (id, status) => {
    const newSurveys = [...surveys]
    newSurveys.forEach((el) => {
      if (el.id === id) {
        el.isSettingAttributes = status
      }
    })
    setSurveys(newSurveys)
  }

  const addAttributeName = (id, question_index, name) => {
    const newSurveys = [...surveys]
    newSurveys.forEach((el) => {
      if (el.id === id) {
        if (el.attributes) {
          el.attributes[question_index] = name
        } else {
          el.attributes = {
            [question_index]: name,
          }
        }
      }
    })
    setSurveys(newSurveys)
  }

  const deleteAttributeName = (id, question_index) => {
    const newSurveys = [...surveys]
    newSurveys.forEach((el) => {
      if (el.id === id) {
        delete el.attributes[question_index]
      }
    })
    setSurveys(newSurveys)
  }

  const assignLabelToSurvey = (id, value) => {
    const newSurveys = [...surveys]
    newSurveys.forEach((el) => {
      if (el.id === id) {
        if (el.grouping_labels?.length > 0) {
          el.grouping_labels = [...el.grouping_labels, value]
        } else {
          el.grouping_labels = [value]
        }
      }
    })
    setSurveys(newSurveys)
  }

  const removeLabelFromSurvey = (id, value) => {
    const newSurveys = surveys.map((el) => {
      if (el.id === id) {
        const newGroupingLabels = el.grouping_labels.filter(
          (label) => label !== value
        )

        return { ...el, grouping_labels: newGroupingLabels }
      }

      return el
    })
    setSurveys(newSurveys)
  }

  const editSurveyQuestion = (surveyId, questionId, question) => {
    const newSurveys = surveys.map((el) => {
      if (el.id === surveyId) {
        const newStructure = el.structure.map((field) => {
          if (field.id === questionId) {
            return { ...field, question }
          }
          return field
        })

        return { ...el, structure: newStructure }
      }

      return el
    })
    setSurveys(newSurveys)
  }

  const removeSurveyResponse = (responseId) => {
    const newResponses = [
      ...surveyResponse.filter((el) => el.id !== responseId),
    ]

    setSurveyResponse(newResponses)
  }

  // helpers
  const [view, setView] = useState(VIEWS.SURVEYS)
  const [isHintOpen, setIsHintOpen] = useState(null)

  const redirectToSandbox = () => setView(VIEWS.SANDBOX)
  const redirectToSurveys = () => setView(VIEWS.SURVEYS)
  const redirectToFeedback = () => setView(VIEWS.FEEDBACK)

  // sandbox
  const emptySandboxSurvey = [
    {
      id: uniqid(),
      type: undefined,
      question: '',
      answers: [],
      required: true,
      range: undefined,
    },
  ]

  const [sandboxSurvey, setSandboxSurvey] = useState(emptySandboxSurvey)
  const resetSandboxSurvey = () => setSandboxSurvey(emptySandboxSurvey)

  const [isTemplate, setIsTemplate] = useState()

  const context = {
    view,
    setView,
    surveyToken,
    setSurveyToken,
    surveys,
    setSurveys,
    removeSurvey,
    switchSurveyStatus,
    surveysLoading,
    setSurveysLoading,
    VIEWS,
    surveyFeedback,
    setSurveyFeedback,
    hasAccess,
    setHasAccess,
    surveyResponse,
    setSurveyResponse,
    feedbackType,
    setFeedbackType,
    isHintOpen,
    setIsHintOpen,
    redirectToSandbox,
    redirectToSurveys,
    redirectToFeedback,
    sandboxSurvey,
    setSandboxSurvey,
    resetSandboxSurvey,
    isTemplate,
    setIsTemplate,
    switchSavingAttributes,
    addAttributeName,
    deleteAttributeName,
    settings,
    setSettings,
    assignLabelToSurvey,
    removeLabelFromSurvey,
    editSurveyQuestion,
    removeSurveyResponse,
  }

  return <Context.Provider value={context}>{children}</Context.Provider>
}

export { StoreProvider }
